// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".messageSMS{min-height:736px;height:812px}span.navbar-brand span{color:#000}span.navbar-brand img{height:60px}.message-content h2{padding-left:15px;padding-right:15px}.message-content a{color:#5867dd}.message-content .image img{width:100%!important}.player-wrapper{margin:0 auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
